
<template>
  <div>
    <div id="print-report">
      <!-- Print Only -->
      <HeaderPrint />
      <!-- / Print Only -->
      <v-card>
        <div class="pa-2 d-print-none">
          <v-row no-gutters class="align-center">
            <!-- Btn Impressão -->
            <v-col cols="5" sm="5" md="4">
              <v-btn
                small
                class="white black--text d-print-none"
                @click="$printReport()"
              >
                <v-icon small left>mdi-printer</v-icon>
                {{ $t("print") }}
              </v-btn>
            </v-col>

            <!-- Agrupado/Lista -->
            <v-col cols="7" sm="10" md="8" class="text-right">
              <v-btn-toggle v-model="toggle_exclusive" dense mandatory>
                <v-btn @click="buildTableFormat('grouped')">
                  <v-icon small left>mdi-account-group</v-icon>
                  <span>{{ $t("grouped") }}</span>
                </v-btn>
                <v-btn @click="buildTableFormat('list')">
                  <v-icon small left>mdi-format-list-bulleted</v-icon>
                  <span>{{ $t("list") }}</span>
                </v-btn>
              </v-btn-toggle>
            </v-col>

            <!-- Lista ou Card (apenas mobile) -->
            <v-col cols="12" v-if="typeList" class="d-md-none mt-3">
              <div class="text-right">
                <v-btn-toggle dense>
                  <v-btn @click="breakpoint = 0">
                    <v-icon>mdi-view-list</v-icon>
                  </v-btn>
                  <v-btn @click="breakpoint = 'xs'">
                    <v-icon>mdi-view-grid</v-icon>
                  </v-btn>
                </v-btn-toggle>
              </div>
            </v-col>

            <!-- Search -->
            <v-col cols="12" md="8" v-if="typeList"> </v-col>
            <v-col cols="12" md="4" v-if="typeList">
              <div class="text-right d-flex mt-3">
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  :label="$t('search')"
                  single-line
                  hide-details
                  dense
                  solo-inverted
                  clearable
                ></v-text-field>
              </div>
            </v-col>
          </v-row>
        </div>

        <!-- ======================= -->
        <!-- FORMAT LIST (DATATABLE) -->
        <!-- ======================= -->
        <v-data-table
          v-if="typeList"
          :headers="headers"
          :items="data"
          :search="search"
          :items-per-page="10"
          item-class="text--red"
          :sort-by="'name_region'"
          :sort-desc="true"
          :mobile-breakpoint="breakpoint"
          :footer-props="{
            'items-per-page-text': this.$t('rowsPerPage'),
          }"
        >
          <!-- Negative Values - (Red Text) -->
          <template v-slot:item.commission_bets="{ item }">
            <span class="red--text"> -{{ item.commission_bets }} </span>
          </template>
          <template v-slot:item.comission_local="{ item }">
            <div>
              <v-chip x-small>
                {{ typeCommissionText(item.type_comission) }}
              </v-chip>
            </div>
            <span :class="getColor(item.comission_local)">
              {{ item.comission_local }}
            </span>
          </template>
          <template v-slot:item.comission_regional="{ item }">
            <span :class="getColor(item.comission_regional)">
              {{ item.comission_regional }}
            </span>
          </template>
          <template v-slot:item.prizes_paid="{ item }">
            <span class="red--text"> -{{ item.prizes_paid }} </span>
          </template>

          <!-- Positive Values - (Green Text) -->

          <template v-slot:item.sales_bets="{ item }">
            <span :class="getColor(item.sales_bets)">
              {{ item.sales_bets }}
            </span>
          </template>
          <template v-slot:item.gross_profit="{ item }">
            <span :class="getColor(item.gross_profit)">
              {{ item.gross_profit }}
            </span>
          </template>
          <template v-slot:item.liquid_profit="{ item }">
            <span :class="getColor(item.liquid_profit)">
              {{ item.liquid_profit }}
            </span>
          </template>

          <template v-slot:item.name_regional="{ item }">
            <a
              class="orange--text"
              @click="
                $profile.showProfileDrawer(
                  item.id_regional,
                  'administrator/regionals/getRegional'
                )
              "
            >
              <v-icon color="orange" x-small>mdi-account-tie</v-icon>
              {{ item.name_regional }}
            </a>
          </template>
          <template v-slot:item.name_local="{ item }">
            <a
              class="green--text"
              @click="
                $profile.showProfileDrawer(
                  item.id_local,
                  'administrator/locals/getLocal'
                )
              "
            >
              <v-icon color="green" x-small>mdi-account-multiple</v-icon>
              {{ item.name_local }}
            </a>
          </template>
          <template v-slot:item.name_agent="{ item }">
            <a
              class="blue--text"
              @click="
                $profile.showProfileDrawer(
                  item.id_agent,
                  'administrator/agents/getAgent'
                )
              "
            >
              <v-icon color="blue" x-small>mdi-account</v-icon>
              {{ item.name_agent }}
            </a>
          </template>
        </v-data-table>

        <!-- =================================== -->
        <!-- FORMAT GROUPED USERS (SIMPLE TABLE) -->
        <!-- =================================== -->
        <v-simple-table v-else>
          <thead>
            <tr>
              <th
                v-for="(head, indexHeader) in headers"
                :key="`${indexHeader} ${head.value}`"
              >
                {{ head.text }}
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      small
                      icon
                      v-bind="attrs"
                      v-on="on"
                      class="d-print-none"
                    >
                      <v-icon small color="info">
                        mdi-information-outline
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>{{ infoKey(head.value) }}</span>
                </v-tooltip>
              </th>
            </tr>
          </thead>
          <tbody>
            <template v-for="item in dataGrouped">
              <!-- For Região -->
              <tr :key="item.id_region">
                <td :colspan="headers.length">
                  {{ item.name_region }}
                </td>
              </tr>
              <!-- For Areas -->
              <template v-for="area in item.areas">
                <tr :key="area.id_area">
                  <td class="pl-8" :colspan="headers.length">
                    {{ area.name_area }}
                  </td>
                </tr>
                <!-- For Users -->
                <template v-for="user in area.users">
                  <tr :key="user.id_agent">
                    <td class="pl-10">
                      <v-icon color="blue" small>mdi-account</v-icon>
                      {{ user.name_agent }}
                    </td>
                    <td>{{ user.count_bets }}</td>
                    <td :class="getColor(user.sales_bets)">
                      {{ user.sales_bets }}
                    </td>
                    <td :class="getColor(user.commission_bets * -1)">
                      {{ user.commission_bets * -1 }}
                    </td>
                    <td :class="getColor(user.prizes_paid * -1)">
                      {{ user.prizes_paid * -1 }}
                    </td>
                    <td :class="getColor(user.comission_local)">
                      {{ user.comission_local }}
                    </td>
                    <td :class="getColor(user.gross_profit)">
                      {{ user.gross_profit }}
                    </td>
                    <td :class="getColor(user.comission_regional)">
                      {{ user.comission_regional }}
                    </td>
                  </tr>
                </template>

                <tr
                  :key="area.name_area"
                  class="text-uppercase font-weight-bold"
                  :class="
                    $vuetify.theme.dark ? 'grey darken-2' : 'yellow lighten-3'
                  "
                >
                  <td>Total da Área</td>
                  <td>
                    {{ area.totalArea.count_bets }}
                  </td>
                  <td :class="getColor(area.totalArea.sales_bets)">
                    {{ area.totalArea.sales_bets }}
                  </td>
                  <td :class="getColor(area.totalArea.commission_bets)">
                    {{ area.totalArea.commission_bets }}
                  </td>
                  <td :class="getColor(area.totalArea.prizes_paid)">
                    {{ area.totalArea.prizes_paid }}
                  </td>
                  <td :class="getColor(area.totalArea.comission_local)">
                    {{ area.totalArea.comission_local }}
                  </td>
                  <td :class="getColor(area.totalArea.gross_profit)">
                    {{ area.totalArea.gross_profit }}
                  </td>
                  <td :class="getColor(area.totalArea.comission_regional)">
                    {{ area.totalArea.comission_regional }}
                  </td>
                </tr>
              </template>
            </template>
          </tbody>
        </v-simple-table>
      </v-card>

      <!-- Resume -->
      <div class="mt-4" v-if="data.length != 0">
        <v-row>
          <v-col v-if="$vuetify.breakpoint.smAndUp" sm="6" md="8"></v-col>
          <v-col cols="12" xs="12" sm="6" md="4">
            <v-card class="pa-3">
              <div class="subtitle-1 mb-2">
                {{ $t("periodSummary") }}
                <v-icon class="float-right mr-3" @click="$copy(resumePrint)">
                  mdi-content-copy
                </v-icon>
                <div class="caption">{{ $store.state.rangeUI }}</div>
              </div>
              <v-simple-table>
                <template v-slot:default>
                  <tbody>
                    <tr>
                      <td class="caption">{{ $t("qtyAgents") }}</td>
                      <td class="text-right">
                        {{ keysResume.qtdAgents.value }}
                      </td>
                    </tr>
                    <tr>
                      <td class="caption">{{ $t("qtyBets") }}</td>
                      <td class="text-right">
                        {{ keysResume.count_bets.value }}
                      </td>
                    </tr>
                    <tr>
                      <td class="caption">{{ $t("bets") }}</td>
                      <td class="text-right green--text">
                        {{ keysResume.sales_bets.value }}
                      </td>
                    </tr>
                    <tr>
                      <td class="caption">{{ $t("coAgentSalesBets") }}</td>
                      <td class="text-right red--text">
                        {{ keysResume.commission_bets.value }}
                      </td>
                    </tr>
                    <tr>
                      <td class="caption">{{ $t("awards") }}</td>
                      <td class="text-right red--text">
                        {{ keysResume.prizes_paid.value }}
                      </td>
                    </tr>
                    <tr>
                      <td class="caption">{{ $t("coGerLocal") }}</td>
                      <td
                        class="text-right"
                        :class="getColor(keysResume.comission_local.value)"
                      >
                        {{ keysResume.comission_local.value }}
                      </td>
                    </tr>
                    <tr>
                      <td class="caption">{{ $t("grossProfit") }}</td>
                      <td
                        class="text-right"
                        :class="getColor(keysResume.gross_profit.value)"
                      >
                        {{ keysResume.gross_profit.value }}
                      </td>
                    </tr>
                    <tr>
                      <td class="caption">{{ $t("regionalCo") }}</td>
                      <td
                        class="text-right"
                        :class="getColor(keysResume.comission_regional.value)"
                      >
                        {{ keysResume.comission_regional.value }}
                      </td>
                    </tr>
                    <tr>
                      <td class="caption">{{ $t("netProfit") }}</td>
                      <td
                        class="text-right"
                        :class="getColor(keysResume.liquid_profit.value)"
                      >
                        {{ keysResume.liquid_profit.value }}
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card>
          </v-col>
        </v-row>
      </div>
    </div>
  </div>
</template>
<script>
import HeaderPrint from "@/components/common/header-print";
export default {
  name: "administrator-financial-sales-report-area",
  components: {
    HeaderPrint,
  },
  data: () => ({
    search: "",
    data: [],
    breakpoint: "xs",
    type: "",
    resume: null,
    keysResume: [],
    list: {
      sales_bets: [],
      commission_bets: [],
      comission_local: [],
      prizes_paid: [],
      gross_profit: [],
      comission_regional: [],
      liquid_profit: [],
      qtdAgents: [],
      count_bets: [],
    },
    headers: [],
    typeList: true,
    toggle_exclusive: undefined,
    dataGrouped: [],
  }),

  mounted() {
    // Table format Default;
    this.buildTableFormat("grouped");
  },

  computed: {
    rangeDate() {
      return this.$store.state.range.date;
    },
    id_regional() {
      return this.$store.state.filters.autocompleteRegionals.id;
    },
    id_local() {
      return this.$store.state.filters.autocompleteLocals.id;
    },
    id_agent() {
      return this.$store.state.filters.autocompleteAgents.id;
    },
    saveFilters() {
      return this.$store.state.filters.save;
    },
  },

  watch: {
    saveFilters(val) {
      val && this.getSales();
    },
    type() {
      this.getSales();
    },
  },

  methods: {
    async getSales() {
      // RESET DADOS
      this.list = {
        sales_bets: [],
        commission_bets: [],
        comission_local: [],
        prizes_paid: [],
        gross_profit: [],
        comission_regional: [],
        liquid_profit: [],
        qtdAgents: [],
        count_bets: [],
      };

      const { id_regional, id_local, id_agent, rangeDate } = this;
      const body = { ...rangeDate, id_regional, id_local, id_agent };

      await this.$request
        .post("/administrator/retail/financial/salesReportArea", body)
        .then((response) => {
          if (!response.dados) return;
          // console.log("response.dados");
          // console.log(response.dados);
          this.data = response.dados;
          this.data.forEach((item) => {
            // De acordo com o type_comission "bruto" ou "ngr" o valor a comissão do Local será alterada
            // Caso seja 'ngr' o valor do somatório será commission_ngr_local
            if (item.type_comission == "ngr") {
              if (item.comission_ngr_local < "0") {
                item.comission_local = "0";
              } else {
                item.comission_local = (
                  Number(item.comission_ngr_local) * -1
                ).toFixed(2);
              }
              item.gross_profit = item.gross_profit_ngr;
            } else {
              item.comission_local = (
                Number(item.comission_local) * -1
              ).toFixed(2);
            }

            // Comissão do Regional
            // Caso o Lucro Bruto seja negativo o regional deve ao operador
            item.comission_regional = (
              item.gross_profit *
              ((item.comission_regional * -1) / 100)
            ).toFixed(2);

            // Lucro Líquido
            item.liquid_profit = (
              Number(item.gross_profit) + Number(item.comission_regional)
            ).toFixed(2);

            // Adiciona valores ao resume para realizar a soma
            this.list.sales_bets.push(Number(item.sales_bets));
            this.list.commission_bets.push(Number(item.commission_bets));
            this.list.comission_local.push(Number(item.comission_local));
            this.list.prizes_paid.push(Number(item.prizes_paid));
            this.list.gross_profit.push(Number(item.gross_profit));
            this.list.comission_regional.push(Number(item.comission_regional));
            this.list.liquid_profit.push(Number(item.liquid_profit));
            this.list.count_bets.push(Number(item.count_bets));
          });

          this.resumeData(this.data);
          this.buildGroupedReport(this.data);
        })
        .catch((error) => {
          this.data = [];
          console.log(error);
        });
    },

    // Construindo o Array Agrupado para as Areas
    buildGroupedReport(data) {
      var listGrouped = [];
      var idRegion = null;
      var idArea = null;

      // Array de Regiões
      for (let item of data) {
        let itemData = {};
        // Região Pai
        if (item.id_region != idRegion) {
          idRegion = item.id_region;
          itemData.id_region = idRegion;
          itemData.name_region = item.name_region;
          itemData.areas = [];
          listGrouped.push(itemData);
        }
      }

      // Array de áreas
      for (let item_grouped of listGrouped) {
        for (let item of data) {
          if (item_grouped.id_region == item.id_region) {
            if (item.id_area != idArea) {
              idArea = item.id_area;
              item_grouped.areas.push({
                id_area: item.id_area,
                name_area: item.name_area,
                users: [],
              });
            }
          }
        }
      }

      // Array de usuários por áreas
      for (let item_grouped of listGrouped) {
        for (let area of item_grouped.areas) {
          for (let item of data) {
            if (item.id_area == area.id_area) {
              area.users.push(item);
            }
          }
        }
      }

      // Somando as áreas
      for (let item_grouped of listGrouped) {
        for (let area of item_grouped.areas) {
          var items = {};
          // Chaves que devem ser somadas:
          const keys = [
            "count_bets",
            "sales_bets",
            "commission_bets",
            "comission_local",
            "prizes_paid",
            "gross_profit",
            "comission_regional",
          ];
          // Função Somadora
          const reducer = (previousValue, currentValue) =>
            previousValue + currentValue;
          // 1. Criação de Objeto com os Arrays onde
          // os valores serão somados com a função reduceer
          let obj = new Object();
          keys.forEach((key) => {
            obj[key] = [];
          });
          // 2. Alimentando os Arrays do Objeto acima com os valores
          area.users.forEach((element) => {
            Object.entries(element).forEach(([key, value]) => {
              keys.forEach((key_resume) => {
                if (key === key_resume) {
                  obj[key].push(Number(value));
                }
              });
            });
          });
          // 3. Criando o Obejto de Items e Somando os valores;
          keys.forEach((key) => {
            items[key] = obj[key].reduce(reducer).toFixed(2);
          });

          // Atribuindo a linha
          area.totalArea = items;
        }
      }

      this.dataGrouped = listGrouped;
    },

    // Resume Data
    resumeData(data) {
      if (!data) return;

      let resume = {
        sales_bets: {},
        commission_bets: {},
        comission_local: {},
        prizes_paid: {},
        gross_profit: {},
        comission_regional: {},
        liquid_profit: {},
        qtdAgents: { value: data.length },
        count_bets: {},
      };

      const reducer = (accumulator, currentValue) => accumulator + currentValue;

      resume.sales_bets.value = this.list.sales_bets.reduce(reducer).toFixed(2);

      resume.commission_bets.value = (
        this.list.commission_bets.reduce(reducer) * -1
      ).toFixed(2);
      resume.comission_local.value = (
        this.list.comission_local.reduce(reducer) * -1
      ).toFixed(2);
      resume.prizes_paid.value = (
        this.list.prizes_paid.reduce(reducer) * -1
      ).toFixed(2);
      resume.gross_profit.value = this.list.gross_profit
        .reduce(reducer)
        .toFixed(2);
      resume.comission_regional.value = this.list.comission_regional
        .reduce(reducer)
        .toFixed(2);
      resume.liquid_profit.value = this.list.liquid_profit
        .reduce(reducer)
        .toFixed(2);
      resume.count_bets.value = this.list.count_bets.reduce(reducer);
      this.keysResume = resume;
      this.resumeExcelCopy();
    },

    typeCommissionText(type_comission) {
      const commissionLocal = {
        ngr: "NGR",
        bruto: this.$t("gross"),
      };
      return commissionLocal[type_comission];
    },
    resumeExcelCopy() {
      // Create String with table to Copy on Btn
      this.resumePrint = `${this.keysResume.qtdAgents.value
        .toString()
        .replace(".", ",")}
        ${this.keysResume.count_bets.value.toString().replace(".", ",")}
        ${this.keysResume.sales_bets.value.toString().replace(".", ",")}
        ${this.keysResume.commission_bets.value.toString().replace(".", ",")}
        ${this.keysResume.prizes_paid.value.toString().replace(".", ",")}
        ${this.keysResume.comission_local.value.toString().replace(".", ",")}
        ${this.keysResume.gross_profit.value.toString().replace(".", ",")}
        ${this.keysResume.comission_regional.value.toString().replace(".", ",")}
        ${this.keysResume.liquid_profit.value.toString().replace(".", ",")}`;
    },

    buildTableFormat(format) {
      // Headers Default
      this.headers = [
        { text: this.$t("amountBet"), value: "count_bets" },
        { text: this.$t("bets"), value: "sales_bets" },
        { text: this.$t("coAgentBet"), value: "commission_bets" },
        { text: this.$t("awards"), value: "prizes_paid" },
        { text: this.$t("coGerLocal"), value: "comission_local" },
        { text: this.$t("grossProfit"), value: "gross_profit" },
        { text: this.$t("regionalCo"), value: "comission_regional" },
      ];

      if (format === "grouped") {
        this.typeList = false;
        const users = {
          text: this.$t("users"),
          value: "name_agent",
          align: " caption",
        };
        this.headers.unshift(users);
      }

      if (format === "list") {
        this.typeList = true;
        const firstColumns = [
          {
            text: "Regional",
            value: "name_regional",
            align: " caption",
            sortable: false,
          },
          {
            text: "Local",
            value: "name_local",
            align: " caption",
            sortable: false,
          },
          {
            text: this.$t("agent"),
            value: "name_agent",
            align: " caption",
            sortable: false,
          },

          {
            text: this.$t("area"),
            value: "name_area",
            align: " caption",
            sortable: false,
          },
          { text: this.$t("region"), value: "name_region", align: " caption" },
        ];
        firstColumns.forEach((item) => this.headers.unshift(item));
      }
    },

    infoKey: function (key) {
      // console.log(key);
      const info = {
        name_agent: this.$t("agentName"),
        qtdAgents: this.$t("numbersOfAgents"),
        comission_regional: this.$t("commissionRegionalOnGrossProfit"),
        count_bets: this.$t("amountBetsSold"),
        sales_bets: this.$t("bettingSalesValue"),
        cancellations: this.$t("reverseOfCanceledBets"),
        commission_bets: this.$t("agentsCommissiononBettingSales"),
        count_credits: this.$t("amountOFCreditsSold"),
        sales_credits: this.$t("creditSalesAmount"),
        commission_credits: this.$t("agentCommissionInfoKey"),
        prizes_paid: this.$t("awardValue"),
        comission_local: this.$t("localManagerCommissionInfoKey"),
        liquid_profit: this.$t("netProfitResume"),
        gross_profit: this.$t("groosProfitResume"),
      };

      return info[key] || null;
    },

    getColor(value, text) {
      if (text == "count_bets") return;
      if (value == 0) return "grey--text darken-4";
      if (value > 0) return "green--text";
      if (value < 0) return "red--text";
    },
  },
};
</script>
